import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import {
  AUTH_HEADER,
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY,
} from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { FetchUserHQLocationDashBoardType } from "../../../domain/models/user-hq-location-dashboard/fetch-user-hq-location-dashboard";
import { FetchUserHQLocationDashBoard } from "../../../domain/useages/user-hq-location-dashboard/fetch-user-hq-location-dashboard";
import { RemoteUserHQLocationDashBoard } from "../../../data/usecases/user-hq-location-dashboard/remote-fetch-user-hq-location-dashboard";

export interface FetchUserHQLocationDashBoardInterface {
  UserHQLocationDashBoard: FetchUserHQLocationDashBoardType;
  UserHQLocationDashBoardState: FetchState;
  fetchUserHQLocationDashBoard: Function;

}

const initialStates = {
  UserHQLocationDashBoard: {} as FetchUserHQLocationDashBoardType,
  UserHQLocationDashBoardState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchUserHQLocationDashBoardSlice: StateCreator<
  FetchUserHQLocationDashBoardInterface
> = (set) => ({
  ...initialStates,
  fetchUserHQLocationDashBoard: async (
    filter: FetchUserHQLocationDashBoard.Params
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteUserHQLocationDashBoard = new RemoteUserHQLocationDashBoard(
      `${BASE_URL}${Endpoints.FETCH_USER_HQ_LOCATION_DASHBOARD}`,

      axiosHttpClient
    );

    set(() => ({ UserHQLocationDashBoardState: FetchState.LOADING }));
    let result = await remoteUserHQLocationDashBoard.fetch(filter);
    return result;
  },
});
